import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { ServicesPage } from "./pages/ServicesPage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { BookingPage } from "./pages/BookingPage";
import { RealEstatePage } from "./pages/niche/RealEstatePage";
import { CEOOperationsPage } from "./pages/niche/CEOOperationsPage";
import { AgenciesPage } from "./pages/niche/AgenciesPage";
import { HomeFieldServicesPage } from "./pages/niche/HomeFieldServicesPage";
import { RecruitmentPage } from "./pages/niche/RecruitmentPage";
import { BusinessOperationsPage } from "./pages/niche/BusinessOperationsPage";

const ScrollToHash = () => {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToHash />
      <Routes>
        {/* Public Pages */}
        <Route path="/" element={<Layout><HomePage /></Layout>} />
        <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
        <Route path="/how-it-works" element={<Layout><HowItWorksPage /></Layout>} />
        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/book" element={<Layout><BookingPage /></Layout>} />
        {/* Private Direct-URL Landing Pages */}
        <Route path="/real-estate" element={<Layout><RealEstatePage /></Layout>} />
        <Route path="/ceo-operations" element={<Layout><CEOOperationsPage /></Layout>} />
        <Route path="/agencies-professional-services" element={<Layout><AgenciesPage /></Layout>} />
        <Route path="/home-field-services" element={<Layout><HomeFieldServicesPage /></Layout>} />
        <Route path="/recruitment" element={<Layout><RecruitmentPage /></Layout>} />
        <Route path="/business-operations" element={<Layout><BusinessOperationsPage /></Layout>} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
